import { useQuery, QueryFunction } from 'react-query';
import {
    FormResponseDocumentsResponse,
    getDocumentsByResponseId,

} from '../../../../services/apiSLTP/qhse/forms/formResponseDocuments';

type UseFormResponseDocumentsQueryOptions = {
    responseId: string;
};

const fetchFormResponseDocuments: QueryFunction<FormResponseDocumentsResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseFormResponseDocumentsQueryOptions];
    try {
        return await getDocumentsByResponseId(options.responseId);
    } catch (error) {
        throw new Error('An unexpected error occurred while fetching form response documents');
    }
};

export const useFormResponseDocumentsQuery = (options: UseFormResponseDocumentsQueryOptions) => {
    return useQuery(['formResponseDocuments', options], fetchFormResponseDocuments, {
        enabled: !!options.responseId,
    });
};
